/* unplugin-vue-components disabled */import script from "./OptimizeAIprompt.vue?vue&type=script&lang=ts&setup=true"
export * from "./OptimizeAIprompt.vue?vue&type=script&lang=ts&setup=true"

import "./OptimizeAIprompt.vue?vue&type=style&index=0&id=e0416690&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0416690"]])

export default __exports__